module.exports = __webpack_public_path__ + "img/timeline_mainevent-9.dd444274.jpg";